import { Crown } from "lucide-react";
import { useSubscription } from "@/hooks/queries";

export function useIsPremium() {
  const s = useSubscription().data;
  return s?.planId === "premium" && s?.status === "active";
}

export function PremiumBadge({ size = "md", testid = "premium-badge" }) {
  const sm = size === "sm";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-bold text-white bg-gradient-to-r from-[#F59E0B] to-[#EA580C] shadow-[0_4px_12px_-4px_rgba(234,88,12,.6)] ${sm ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[12px]"}`} data-testid={testid}>
      <Crown className={sm ? "w-3 h-3" : "w-3.5 h-3.5"} strokeWidth={2.5} />PREMIUM
    </span>
  );
}

export function AvatarCrown({ children, show }) {
  return (
    <span className="relative inline-flex">
      {children}
      {show && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gradient-to-br from-[#F59E0B] to-[#EA580C] ring-2 ring-white flex items-center justify-center" data-testid="premium-avatar-crown">
          <Crown className="w-3 h-3 text-white" strokeWidth={2.5} />
        </span>
      )}
    </span>
  );
}
